// Re-export style presets from @repo/tokens (single source of truth)
export {
  STYLE_PRESETS,
  STYLE_PRESET_NAMES,
  DEFAULT_STYLE_PRESET,
} from '@repo/tokens';

export type { StylePresetName, StylePreset } from '@repo/tokens';
